var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h1',[_vm._v("Formulário: "+_vm._s(_vm.checklist.formName))])]),_c('checklist-fill',{attrs:{"checklist":_vm.checklist,"token":_vm.$store.getters.token},on:{"finishFilling":_vm.finishFilling}}),_c('b-button',{on:{"click":_vm.finishFilling}},[_vm._v("Voltar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }